import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import LeftPanel from '../LeftPanel';
import RightPanel from '../RightPanel';
import OrderMap from '../OrderMap';

// Styles
import styles from './Map.styl';

const cx = classNames.bind(styles);

export default function Map(props) {
  const { orderData, getOrderStatus } = props;

  return (
    <div className={cx('Map')}>
      <LeftPanel className={cx('Map__left')} orderData={orderData} />
      <RightPanel
        className={cx('Map__right')}
        orderData={orderData}
        getOrderStatus={getOrderStatus}
      />
      <OrderMap className={cx('Map__order')} orderData={orderData} />
    </div>
  );
}

Map.propTypes = {
  orderData: PropTypes.object.isRequired,
  getOrderStatus: PropTypes.func.isRequired,
};
